import { Box, Divider, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { Schema } from '../../../../../amplify/data/resource';
import { formatMoney } from '../../../../utils/format/format';
import EmployeeSidebar from './EmployeeSidebar';
import { useState } from 'react';

// @ts-ignore
type Employee = Schema['Employee']['type'];

interface EmployeeItemProps {
  employee: Employee;
  date: any;
}

const EmployeeItem: React.FC<EmployeeItemProps> = ({ employee, date }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const fileId = searchParams.get('fileId');

  const monthsInHebrew = [
    'ינואר',
    'פברואר',
    'מרץ',
    'אפריל',
    'מאי',
    'יוני',
    'יולי',
    'אוגוסט',
    'ספטמבר',
    'אוקטובר',
    'נובמבר',
    'דצמבר',
  ];

  const [year, month, day] = date.split('-');

  const monthName = monthsInHebrew[parseInt(month, 10) - 1];
  const yearNumber = parseInt(year, 10);

  const totalContributions = employee?.employeeContributionAllocation?.reduce(
    (total: number, contribution: any) =>
      total + contribution?.contributionAmount,
    0,
  );

  const handleOpenEmployeeSidebar = () => {
    setSidebarOpen(true);
  };

  const handleCloseEmployeeSidebar = () => {
    setSidebarOpen(false);
  };

  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row-reverse',
          justifyContent: 'space-between',
          backgroundColor: '#FFF',
          py: '20px',
          px: '30px',
          borderRadius: '10px',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        onClick={handleOpenEmployeeSidebar}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row-reverse',
            gap: '30px',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row-reverse',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            <img alt="card" src="/assets/file/employees/card.svg" />
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography
                fontWeight={'700'}
                fontSize={'16px'}
                fontFamily={'AlmoniDL'}
                textAlign={'right'}
                width={'120px'}
              >
                {employee.firstName} {employee.lastName}
              </Typography>
              <Typography
                fontWeight={'700'}
                fontSize={'14px'}
                textAlign={'right'}
                fontFamily={'Montserrat'}
              >
                {employee.employeeId}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              py: '10px',
              px: '20px',
              borderRadius: '10px',
              backgroundColor: '#F2F4F7',
              flexDirection: 'row-reverse',
              alignItems: 'center',
              gap: '14px',
              minWidth: '130px',
            }}
          >
            <img src="/assets/file/employees/coin.svg" alt="Coin" />
            <Typography
              fontWeight={'700'}
              fontSize={'24px'}
              fontFamily={'Montserrat'}
            >
              {formatMoney(totalContributions || 0)}
            </Typography>
          </Box>

          <Box
            sx={{
              display: 'flex',
              py: '10px',
              px: '20px',
              borderRadius: '10px',
              backgroundColor: '#F2F4F7',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Typography
                fontWeight={'700'}
                fontSize={'16px'}
                fontFamily={'AlmoniDL'}
              >
                {monthName}
              </Typography>
              <Typography
                fontWeight={'700'}
                fontSize={'14px'}
                fontFamily={'Montserrat'}
              >
                {yearNumber}
              </Typography>
            </Box>
          </Box>
          <Divider orientation="vertical" flexItem />
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography
              textAlign={'right'}
              fontWeight={'700'}
              fontSize={'16px'}
              fontFamily={'AlmoniDL'}
            ></Typography>
            <Typography
              textAlign={'right'}
              fontWeight={'700'}
              fontSize={'14px'}
              fontFamily={'Montserrat'}
            ></Typography>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#DCEAE433',
            width: '40px',
            height: '40px',
            borderRadius: '10px',
          }}
        >
          <img alt="arrow" src="/assets/file/employees/arrow.svg" />
        </Box>
      </Box>
      {sidebarOpen && 1}
      <EmployeeSidebar
        open={sidebarOpen}
        onClose={handleCloseEmployeeSidebar}
        employeeId={employee.employeeId || ''}
      />
    </>
  );
};

export default EmployeeItem;
